import React from 'react'
import { generateUrlParameters } from '../../../helpers/recommendationsAnalytics'

const hasMultiplePrices = false

const citrusBeaconReport = (adId, type = 'first-i') => {
  if (adId) {
    navigator.sendBeacon(`/citrus/resource/${type}/${adId}`)
  }
}

const reducer = (accumulator, product) => {
  const { price: prices, reviewstatistics: reviews = {}, name, badge, madeToOrder } = product?.attributes || {}
  if (!name || !prices) return accumulator
  const { flashText: specialOfferText, was: wasPrice, now: price } = prices
  const { avgRating: rating, reviewCount: reviewsCount } = reviews
  const { id: productId, citrusId } = product
  const path = `/product/${productId}`
  const { parentPartNumber, analyticsData } = accumulator
  const { innerPlacement, sectionPlacement, sectionTitle, strategy } = analyticsData
  const trackingOptions = { sectionPlacement, innerPlacement, sectionTitle, strategy }
  const urlInfo = { fromProduct: parentPartNumber, toProduct: productId, ...trackingOptions }
  const query = generateUrlParameters(urlInfo)
  const productLink = path + query
  const priceOptions = { hasMultiplePrices, wasPrice, price }
  const offerOptions = { specialOfferText }
  const ratingOptions = { rating }
  const productOptions = { name, partNumber: productId, href: productLink, reviewsCount }
  const options = {
    citrusId,
    badge,
    madeToOrder,
    ...priceOptions,
    ...offerOptions,
    ...ratingOptions,
    ...productOptions,
    cta: <></>,
    onClick: () => citrusBeaconReport(citrusId, 'second-c')
  }
  accumulator.items.push(options)
  return accumulator
}

const getProductOptions = (products, parentPartNumber, analyticsData) => {
  const initialValue = { items: [], parentPartNumber, analyticsData }
  return products.reduce(reducer, initialValue).items
}

export { getProductOptions, citrusBeaconReport } // eslint-disable-line
